module.exports = __webpack_public_path__ + "img/001-photo.aa962bc3.png";